import { render } from "./ConsumptionSection.vue?vue&type=template&id=7702d4ca&ts=true"
import script from "./ConsumptionSection.vue?vue&type=script&lang=ts"
export * from "./ConsumptionSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__